import { AvailableChildrenType, SugarElementInfo } from "../../Suggester/SugarElementInfo";

export const startTour: SugarElementInfo = {
    name: "startTour",
    availableChildren: { type: AvailableChildrenType.Any },
};
